import { ConsolaInstance, createConsola, consola } from "consola";

export type Logger = ConsolaInstance;

export function renderJobStartIcon() {
	return `\x1b[38;2;217;119;6m◻︎ ◻︎\x1b[0m`;
}


export function renderJobEndIcon() {
	return `\x1b[38;2;217;119;6m◼︎ ◼︎\x1b[0m`;
}

/**
 * Creates a logger instance with a tag prefix
 * @param tag - Tag to prefix all log messages (e.g., "API", "DB", "Auth")
 * @param base_logger - Optional base logger to extend from (defaults to consola)
 * @returns A new logger instance with the tag
 */
export function createLogger(tag: string, base_logger?: Logger): Logger {
	const baseInstance = base_logger || createConsola({
		formatOptions: {
			columns: 1,
			date: true,
			colors: true,
		}
	});
	return baseInstance.withTag(tag);
}
